<template>
  <div>
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-form-group>
      <b-container>
        <b-row>
          <b-col xl="9" v-if="properties.length" class="modal-select">
            <model-select
              :options="properties"
              v-model="propertyId"
              placeholder="Gebäude auswählen"
              :isDisabled="isModalEdit"
            />
          </b-col>
          <b-col xl="3" class="add-btn" v-if="!isModalEdit">
            <div class="button-wrapper-icon" v-b-modal.modal-multi-property>
              <span class="icon-add_circle_outline"></span>
              <span class="text-person">Gebäude</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-form-group>
  </div>
</template>

<script>
  import 'vue-search-select/dist/VueSearchSelect.css'
  import { ModelSelect } from 'vue-search-select'
  import { mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      properties: []
    }),
    created () {
      this.getProperties()
    },
    methods: {
      async getProperties () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('property/GET_MY_PROPERTIES').then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const properties = data.liegenschaften.nodes

          const renamedProperties = properties.map(property => ({
            gemeindeId: property.gemeindeId,
            text: property.gebaeudeartBezeichnung + ' - ' + property.adresse + ' - ' + property.nutzungsartBezeichnung,
            value: property.liegenschaftId
          }))

          this.properties = renamedProperties
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    props: {
      isModalEdit: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapState({
        isPropertyModalVisible: state => state.application.isPropertyModalVisible
      }),
      propertyId: {
        set (value) {
          let gemeindeId = null
          const property = this.properties.filter(property => property.value === value)

          if (Array.isArray(property) && property.length) {
            gemeindeId = property[0].gemeindeId
          }

          this.$store.commit('application/SET_APPLICATION_COMMUNITY', gemeindeId)
          this.$store.commit('application/SET_APPLICATION_PROPERTY_ID', value)
          this.$store.commit('application/SET_APPLICATION_PROPERTY_TYPE', null)
        },
        get () {
          return this.$store.state.application.createApplication.propertyId
        }
      }
    },
    watch: {
      isPropertyModalVisible (newValue, oldValue) {
        if (newValue !== oldValue && !this.isPropertyModalVisible) {
          this.getProperties()
        }
      }
    },
    components: {
      ModelSelect
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding: 0
  }

  .icon-add_circle_outline{
    font-size: 20px !important;
  }

  .add-btn{
    margin-top: 0;

     @include media-breakpoint-down(lg) {
       margin-top: 1rem;
     }
  }
</style>
